import React, { ElementType, FC, useState } from "react";

import { useTranslation } from "react-i18next";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import { Tooltip } from "@/components/atoms";
import BottomSheet, { BottomSheetData } from "@/components/molecules/BottomSheet/BottomSheet";
import { shouldBeHidden } from "@/components/organisms/DetailPanels/DetailPanel/shouldBeHidden";
import { sanitizeHtml } from "@/core/security";
import { StyledBottomSheetButton } from "@/styles/components";

export type LabelValueProps = {
    key: string;
    label: string;
    value: string | number;
    color?: string;
    hideIfZero?: boolean;
    isLink?: boolean;
    tooltip?: string;
    onClick?: () => void;
    IconComponent?: ElementType;
};

const LabelValue: FC<LabelValueProps> = (props) => {
    const { label, value, color = "var(--color-grey-900)", isLink = false, tooltip, onClick, IconComponent } = props;

    const { t } = useTranslation();

    const theme = useTheme();
    const isMobileScreen = useMediaQuery(theme.breakpoints.down("sm"));
    const [bottomSheetData, setBottomSheetData] = useState<BottomSheetData>(null);

    if (shouldBeHidden(props)) {
        return <></>;
    }

    const clickable = !!onClick;

    return (
        <>
            <div className="infoContainer" data-testid={`înfo-item-${label}`}>
                <span className="labelPanel" data-testid="înfo-item-label">
                    {label}

                    {tooltip && !isMobileScreen && (
                        <>
                            {` `}
                            <Tooltip label={tooltip} />
                        </>
                    )}
                </span>
                <div
                    className="valueWrap"
                    onClick={clickable ? onClick : undefined}
                    style={{ cursor: clickable ? "pointer" : "default" }}
                    data-testid="înfo-item-value"
                >
                    {IconComponent && <IconComponent />}
                    {isLink ? (
                        <span
                            className="valuePanel"
                            style={{ color: color }}
                            dangerouslySetInnerHTML={{
                                __html: sanitizeHtml(value?.toString() || "-", { ADD_ATTR: ["target"] }),
                            }}
                        />
                    ) : (
                        <span className="valuePanel" style={{ color: color }}>
                            {t(value?.toString()) || value?.toString()}
                        </span>
                    )}
                </div>
            </div>
            {tooltip && (
                <>
                    <div className="infoContainer">
                        <StyledBottomSheetButton
                            $hideDesktop
                            $inline={false}
                            onClick={() => setBottomSheetData({ title: label, content: t(tooltip) })}
                        >
                            {t("Common.MoreInformations")}
                        </StyledBottomSheetButton>
                    </div>
                    {bottomSheetData && (
                        <BottomSheet
                            title={bottomSheetData.title}
                            content={bottomSheetData.content}
                            handleOverlayClick={() => setBottomSheetData(null)}
                        />
                    )}
                </>
            )}
        </>
    );
};

export default LabelValue;
